import { render } from "./CasHregister.vue?vue&type=template&id=00b92326"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/CasHregister.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00b92326"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00b92326', __exports__)) {
    api.reload('00b92326', __exports__)
  }
  
  module.hot.accept("./CasHregister.vue?vue&type=template&id=00b92326", () => {
    api.rerender('00b92326', render)
  })

}


export default __exports__